import localStorageKey from "../../enumerations/localStorageKey";
import { envChangeType } from "../../plugins/utils";

export const useFacebookPixel = () => {
  const pixelCreateCustomTracker = ({ eventId, props = {} }) => {
    window?.fbq("trackCustom", eventId, props);
  };

  const pixelCreateTracker = ({ props = {}, eventId = "" }) => {
    window?.fbq("track", eventId, {
      ...props,
      currency:
        localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
        envChangeType("REACT_APP_DEFAULT_CURRENCY"),
    });
  };

  return {
    isHavePixelIntegration: !!envChangeType("REACT_APP_HEAD_FBPIXEL_ID"),
    pixelCreateCustomTracker,
    pixelCreateTracker,
  };
};
